'use client';

import type { ReactNode } from 'react';
import { useTranslations } from 'next-intl';
import { Box } from '@terra/ui-styled-system';
import { Checkbox, isArchivedLifecycle } from '@terra/ui-design-system';
import type { GroupedSignal } from '@terra/shared-contracts-signals';
import { rowClickBlockerProps } from '../rowClickBlocker';
import { useSignalsTableContext } from './SignalsTableContext';

function SelectionCheckboxFrame({ children }: { children: ReactNode }) {
  return (
    <Box
      w="full"
      h="full"
      display="flex"
      alignItems="center"
      justifyContent="center"
      {...rowClickBlockerProps}
    >
      {children}
    </Box>
  );
}

export function SignalsTableSelectAllHeader() {
  const t = useTranslations('proxy.signals.table');
  const { headerCheckboxState, isSelectAllDisabled, onSelectAll } =
    useSignalsTableContext();

  return (
    <SelectionCheckboxFrame>
      <Checkbox
        size="sm"
        aria-label={t('selectAll')}
        checked={headerCheckboxState}
        disabled={isSelectAllDisabled}
        onCheckedChange={(details) => onSelectAll(details.checked === true)}
      />
    </SelectionCheckboxFrame>
  );
}

export function SignalsTableSelectionCell({
  signal,
}: {
  signal: GroupedSignal;
}) {
  const t = useTranslations('proxy.signals.table');
  const { isSignalSelected, isSelectionDisabled, onSelectSignal } =
    useSignalsTableContext();

  return (
    <SelectionCheckboxFrame>
      <Checkbox
        size="sm"
        aria-label={t('selectSignal')}
        checked={isSignalSelected(signal)}
        disabled={isSelectionDisabled || isArchivedLifecycle(signal.lifecycle)}
        onCheckedChange={(details) =>
          onSelectSignal({
            signalId: signal.id,
            shouldSelect: details.checked === true,
          })
        }
      />
    </SelectionCheckboxFrame>
  );
}
